export enum ActionsTypes {
  CACLULATE_BMR = "CACLULATE_BMR",
  CACLULATE_MACRO = "CACLULATE_MACRO",
  SET_NEWDATE = "CACLULATE_NEWDATE",
  SET_BASICINFO = "CACLULATE_BASICINFO",
  SET_GOAL = "SET_GOAL",
}
